import { useLocalEstoqueCombo } from "@/features/estoque/hooks/useLocalEstoque";

/** Exibe a descrição do local de estoque a partir do ID (0/ausente → "—"). */
export function LocalEstoqueNome({ id }: { id?: number | null }) {
  const { data: locais = [] } = useLocalEstoqueCombo();
  if (!id) return <span className="text-muted-foreground">—</span>;
  return <>{locais.find((l) => l.id === id)?.descricao ?? `Local ${id}`}</>;
}
